import { render, staticRenderFns } from "./KT-TTInfo.vue?vue&type=template&id=036f2f6a&lang=pug&"
import script from "./KT-TTInfo.vue?vue&type=script&lang=js&"
export * from "./KT-TTInfo.vue?vue&type=script&lang=js&"
import style0 from "./KT-TTInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports